import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-select-document-type-modal',
    templateUrl: './select-document-type-modal.component.html',
    styleUrls: ['./select-document-type-modal.component.scss'],
    standalone: false
})
export class SelectDocumentTypeModalComponent implements OnInit, OnDestroy {
    DocumentType: string = null;
    Options: string[] = [
        'AUTO_CLASSIFICATION_TYPE',
        'CLAIM_TYPE',
        'OFFER_TYPE',
        'INVOICE_TYPE',
        'PHOTO_TYPE',
        'REPORT_TYPE',
        'CASE-ADDITIONAL_TYPE',
        'OTHERS_TYPE'
    ];
    ButtonNoText = 'CANCEL';
    ButtonYesText = 'DONE';
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<SelectDocumentTypeModalComponent>
    ) {}

    ngOnInit(): void {
        this.modalDataInit();
        this.keydownListener();
    }

    modalDataInit() {
        // this.DocumentType = this.data.DefaultSelectedDocumentType;
        this.ButtonNoText =
            this.data.ButtonNoText == null ? null : this.data.ButtonNoText ? this.data.ButtonNoText : this.ButtonNoText;
        this.ButtonYesText =
            this.data.ButtonYesText == null
                ? null
                : this.data.ButtonYesText
                ? this.data.ButtonYesText
                : this.ButtonYesText;
    }

    keydownListener() {
        this.dialogRef
            .keydownEvents()
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => {
                if (event.key == 'Enter') {
                    this.submitForm();
                }
            });
    }

    submitForm() {
        this.dialogRef.close(this.DocumentType);
    }

    cancel() {
        this.dialogRef.close(null);
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
